import React from "react";
// import { MessageItemStyles } from './styles.module';
import * as Styled from "./styles.module";

import { MessageItemImage } from "./MessageItemImage";

import { UserPic } from "../UserPic/UserPic";
import {
  chatDateFormat,
  convertToUsaDateFormat,
  convertToUsaTimeFormat,
} from "../../../helpers/DateHelper";

import { Button } from "../../../components/UIKitComponents/Button/Button";
import { Icon } from "../../../components/UIKitComponents/Icon/Icon";

import {
  SMS_STATUS_PROCESS,
  SMS_STATUS_RECEIVED,
  SMS_STATUS_ERROR,
} from "../../constants";

interface IMessageItemProps {
  msgData: any;
  currentContact: any;
  scrollTopPosition: number;
  defaultVisible: boolean;
}

type Props = IMessageItemProps;

export class MessageItem extends React.Component<Props> {
  myRef: any;
  state: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      visibility: !!props.defaultVisible,
    };
  }

  componentDidUpdate() {
    // if (this.props.msgData.body === "asdqwe rty") {

    if (!this.state.visibility) {
      const elData = this.myRef?.getBoundingClientRect() || 0;
      if (elData.top > 50) {
        this.setState({ visibility: true });
      }
      // console.log('MSG:: ', this.props.scrollTopPosition, elData.top);
    }

    // }
  }

  renderAvatar() {
    return (
      <div className="msg__sender">
        <UserPic
          className="msg__avatar"
          contactData={this.props.currentContact}
          width={30}
          height={30}
        />
      </div>
    );
  }

  renderMedia(media: any) {
    return media.map((it: any, key: number) => (
      <MessageItemImage src={it.url} key={key} />
    ));
  }

  deliveryStatusMap(deliveryStatus: number): string {
    if (deliveryStatus in SMS_STATUS_RECEIVED) return "#5E94FF";
    if (deliveryStatus in SMS_STATUS_PROCESS) return "gray";

    return "gray";
  }

  isNotDelivered(deliveryStatus: number): boolean {
    return deliveryStatus in SMS_STATUS_ERROR;
  }

  render() {
    const isIncoming = this.props.msgData.type === 0;
    const msgType = isIncoming ? "--in" : "--out";
    const body = this.props.msgData?.body || "";
    const date = this.props.msgData?.date || "";
    const media = this.props.msgData?.media || [];
    const senderName = this.props.msgData?.full_name || "";
    const deliveryStatus = this.props.msgData?.status || 8;
    const visibility = !!this.state.visibility;

    const isNotDelivered = this.isNotDelivered(deliveryStatus);
    const showErrorIcon = !isIncoming && isNotDelivered;
    const showDeliveryIcon = !isIncoming && !isNotDelivered;

    // ref={(ref: any) => this.cancelReasonsRef = ref}

    return (
      <Styled.MessageItemStyles
        ref={(ref: any) => (this.myRef = ref)}
        className={`msg ${visibility ? "" : "--invisible"} ${msgType}`}
      >
        {isIncoming ? this.renderAvatar() : ""}
        <div
          className={`msg__body ${msgType}`}
          title={`${convertToUsaDateFormat(date)} ${convertToUsaTimeFormat(date)}`}
        >
          <span className={`msg__text typo typo-text-12 ${msgType}`}>
            {body}
            {this.renderMedia(media)}
          </span>
          <div className="msg__bottom">
            {!isIncoming ? (
              <span className={`msg__sender-name typo typo-text-10 ${msgType}`}>
                {senderName}
              </span>
            ) : (
              ""
            )}
            <span className={`msg__time typo typo-text-10 ${msgType}`}>
              {chatDateFormat(date)}
            </span>

            {showErrorIcon ? (
              <Styled.MessageStatus>
                <Icon color="gray" icon="unavailable" width="16" height="16" />
              </Styled.MessageStatus>
            ) : (
              ""
            )}
            {showDeliveryIcon ? (
              <Styled.MessageStatus>
                <Icon
                  color={this.deliveryStatusMap(deliveryStatus)}
                  icon="checkmark"
                  width="18"
                  height="18"
                />
              </Styled.MessageStatus>
            ) : (
              ""
            )}
          </div>
        </div>
      </Styled.MessageItemStyles>
    );
  }
}
